import {Injectable} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'environments/environment';


/**
 * Prefixes all requests with `environment.serverUrl`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        if (!/^(http|https):/i.test(request.url) && request.url.indexOf('i18n') < 0
            && request.url.indexOf('assets') < 0 && request.url.indexOf('common') < 0) {
            request = request.clone({url: environment.dashboardApiUrl + request.url});
        }

        return next.handle(request);
    }
}
